'use client'

import { Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui'

export interface UserPositionIndicatorProps {
  variant: 'vault' | 'market'
}

/**
 * UserPositionIndicator component - Tailwind replica of dapp-ui-v5 UserPositionIndicator
 *
 * Displays a small green dot indicating the user has an active position in
 * the given vault or market, with an explanatory tooltip on hover/touch.
 *
 * @example
 * ```tsx
 * <UserPositionIndicator variant="vault" />
 * ```
 */
export function UserPositionIndicator({ variant }: UserPositionIndicatorProps) {
  const label = `You have an active position in this ${variant}.`

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div className="bg-success-foreground size-3 shrink-0 grow-0 rounded-full" />
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  )
}
